import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FormFieldColorPicker from '@anwb/poncho/components/form-field-color-picker';
import { PanelStandard } from '@anwb/poncho/components/panel';
import { setChosenLeaseCarColor } from 'store/actions/chosenLeaseCar';
import {
	chosenColorSelector,
	chosenUpgradeSelector,
	isNewCarSelector,
	leaseCarColorsSelector,
	leaseCarDataIdSelector,
} from 'store/selectors';
import { ColorInput } from 'types';
import { getAvailableColorsByUpgrade } from 'utils';

import { mapColorToColorInput } from './utils/mapColorToColorInput';

export const Colors = () => {
	const colorList = useSelector(leaseCarColorsSelector);
	const selectedUpgrade = useSelector(chosenUpgradeSelector);
	const carId = useSelector(leaseCarDataIdSelector);
	const selectedColor = useSelector(chosenColorSelector);
	const isNewCar = useSelector(isNewCarSelector);
	const [inputs, setInputs] = useState<ColorInput[]>([]);
	const dispatch = useDispatch();
	const [currentUpgrade, setCurrentUpgrade] = useState(
		selectedUpgrade ? selectedUpgrade.id : Number(carId)
	);

	useEffect(() => {
		const mapColors = (upgradeId: number) => {
			const availableColors = getAvailableColorsByUpgrade(colorList, upgradeId);
			// initial load
			if (upgradeId === Number(carId) && !selectedColor) {
				dispatch(setChosenLeaseCarColor(availableColors[0]));
			}

			// when upgrade changes
			if (upgradeId !== currentUpgrade) {
				const upgradeIndex = selectedColor?.linkedVehicles.find((id) => upgradeId === id);
				// set the cheapest color if selected color is not available for changed upgrade
				if (!upgradeIndex) {
					dispatch(setChosenLeaseCarColor(availableColors[0]));
				}
			}
			setInputs(mapColorToColorInput(availableColors));
			setCurrentUpgrade(upgradeId);
		};

		if (!isNewCar) {
			// Only the actual color should be present in the colorList
			dispatch(setChosenLeaseCarColor(colorList[0]));
		} else {
			mapColors(selectedUpgrade ? selectedUpgrade.id : Number(carId));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedUpgrade, carId, isNewCar]);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event?.target as HTMLInputElement;
		if (selectedColor?.id !== Number(value)) {
			const chosenColor = colorList.find((color) => color.id === Number(value));

			if (chosenColor) {
				dispatch(setChosenLeaseCarColor(chosenColor));
			}
		}
	};

	return isNewCar ? (
		<PanelStandard title="Kleur" hasOuterSpacing={false}>
			<FormFieldColorPicker
				key={`${currentUpgrade}${selectedUpgrade}`}
				value={selectedColor?.id.toString() || ''}
				inputs={inputs}
				onChange={handleChange}
				required
				gradient
				label=""
			/>
		</PanelStandard>
	) : null;
};
